import React, {Fragment, useState} from 'react'
import PAContentBlock from '../PAContentBlock'
import { PAconnectorChatSlack } from '../PAconnectors';
import { FormGroup, Button, Icon, Notification } from 'xsolla-uikit';
import PAh2 from '../PAh2';


export function PAsettingsContactsFull() {

  const [slack, setSlack] = useState([])

  return (
    <div>
      <PAContentBlock title='Xsolla contacts'>



      <div
        className="gateway-card gateway-card--click-enabled"
        style={{ height: "100%", width: "auto", padding: 16 }}
      >

          <FormGroup indentation='xs'>
            <PAh2 tag="h4" title='Maria Valchuk' indentation='xs' />
            <p>Account manager</p>
          </FormGroup>

          <FormGroup indentation='md'>

          <Button appearance='flatten' href='mailto:m.valchuk@xsolla.com'><Icon name='email'/> m.valchuk@xsolla.com</Button>


          </FormGroup>


      </div>

      </PAContentBlock>

      <PAContentBlock title='Xsolla in your messengers' border={false}>

        <FormGroup indentation="lg">
          <Notification
            icon='info'
            // appearance='minimal'
            status="info"
            // size="sm"
          >
            Read <a style={{
              color: '#0073f7',
              textDecoration: 'underline',
              }} target='_blank' href='https://developers.xsolla.com/'>how to add Xsolla bot to the channel or private group.</a>
          </Notification>
        </FormGroup>


        <FormGroup indentation="lg" key={`slack_0`}>
          <PAconnectorChatSlack connected={true}>
          </PAconnectorChatSlack>
        </FormGroup>


        {slack.map((item, ind)=><FormGroup indentation="lg" key={`slack_${ind}`}>
          <PAconnectorChatSlack connected={false}>
            Add Xsolla chat to manage orders, request support, and get product updates. You can choose the desired Xsolla channels to connect to your current chat platform.
          </PAconnectorChatSlack>
        </FormGroup>)}




        {!slack.length && <FormGroup>
          <Button appearance='flatten'
            onClick={()=>setSlack([...slack.push('1')])}
          ><Icon name='add'/>Add another Slack connection</Button>
        </FormGroup>}


      </PAContentBlock>


    </div>
  )
}


export function PAsettingsContacts() {
  return (
    <div>
      <PAContentBlock title='Xsolla contacts'>



      <div
        className="gateway-card gateway-card--click-enabled"
        style={{ height: "100%", width: "auto", padding: 16 }}
      >

          <FormGroup indentation='xs'>
            <PAh2 tag="h4" title='Maria Valchuk' indentation='xs' />
            <p>Account manager</p>
          </FormGroup>

          <FormGroup indentation='md'>
            <Button appearance='flatten' href='mailto:m.valchuk@xsolla.com'><Icon name='email'/> m.valchuk@xsolla.com</Button>
          </FormGroup>


      </div>

      </PAContentBlock>

      <PAContentBlock title='Xsolla in your messengers' border={false}>

                  <FormGroup indentation="lg">
                  <Notification
                      icon='info'
                      // appearance='minimal'
                      status="info"
                      // size="sm"
                    >
                      Read <a style={{
                        color: '#0073f7',
                        textDecoration: 'underline',
                        }} target='_blank' href='https://developers.xsolla.com/'>how to add Xsolla bot to the channel or private group.</a>
                    </Notification>
                  </FormGroup>


                  <FormGroup indentation="lg">

                    <PAconnectorChatSlack connected={true}>
                    </PAconnectorChatSlack>
                  </FormGroup>

                  <FormGroup indentation="lg">
                    <PAconnectorChatSlack connected={'pending'}>
                    <Notification
                      size='sm'
                      appearance='minimal'
                      title='Please allow 3-4 business days to set up your connection. An Account Manager will contact you.'
                      status="warning"
                      size="sm"
                    />
                    </PAconnectorChatSlack>
                  </FormGroup>


                  <FormGroup indentation="lg">
                    <PAconnectorChatSlack>
                    Add Xsolla chat to manage orders, request support, and get product updates. You can choose the desired Xsolla channels to connect to your current chat platform.
                    </PAconnectorChatSlack>
                  </FormGroup>


                  <FormGroup>
                    <Button appearance='flatten' ><Icon name='add'/>Add another Slack connection</Button>
                  </FormGroup>


      </PAContentBlock>


    </div>
  )
}




export function PAsettingsContactsEmpty() {

  const [slack, setSlack] = useState([])

  return (
    <div>
      <PAContentBlock title='Xsolla contacts'>



      <div
        className="gateway-card gateway-card--click-enabled"
        style={{ height: "100%", width: "auto", padding: 16 }}
      >

          <FormGroup indentation='xs'>
            <PAh2 tag="h4" title='Maria Valchuk' indentation='xs' />
            <p>Account manager</p>
          </FormGroup>

          <FormGroup indentation='md'>

          <Button appearance='flatten' href='mailto:m.valchuk@xsolla.com'><Icon name='email'/> m.valchuk@xsolla.com</Button>


          </FormGroup>


      </div>

      </PAContentBlock>

      <PAContentBlock title='Xsolla in your messengers' border={false}>

        {/* <FormGroup indentation="lg">
          <Notification
            icon='info'
            // appearance='minimal'
            status="info"
            // size="sm"
          >
            Read <a style={{
              color: '#0073f7',
              textDecoration: 'underline',
              }} target='_blank' href='https://developers.xsolla.com/'>how to add Xsolla bot to the channel or private group.</a>
          </Notification>
        </FormGroup> */}





          <PAconnectorChatSlack connected={false}>
            Add Xsolla chat to manage orders, request support, and get product updates. You can choose the desired Xsolla channels to connect to your current chat platform.
          </PAconnectorChatSlack>




      </PAContentBlock>


    </div>
  )
}